exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1F8Kp-y-cooH-u{padding:0 12px}._1F8Kp-y-cooH-u img{width:279px;border-radius:3px}._1F8Kp-y-cooH-u p{text-align:center;font-size:14px;line-height:20px;color:#5e6c84;padding-bottom:8px}.V2neP0mJABTMax{padding-top:15px;font-size:16px;line-height:20px;text-align:center;color:#000}._2E5AuGJn42y7MN{margin-bottom:0;border-radius:3px}", ""]);

// exports
exports.locals = {
	"createTeamPrompt": "_1F8Kp-y-cooH-u",
	"createTeamTitle": "V2neP0mJABTMax",
	"createTeamPromptContinueButton": "_2E5AuGJn42y7MN"
};